import React, { Fragment } from "react";
import { Layout, AppBar, Notification } from "react-admin";
import { UserMenu, MenuItemLink } from "react-admin";

import { Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import {
  ContrastIcon,
  LogoutIcon,
  ProfileIcon,
  ThemeToggleIcon,
} from "../../components/common/iconography";
import { AppBarHeader } from "../../components/common/AppBarHeader";
import { KbChatButton } from "../../components/common/KbChatButton";
import { MenuItemClickable } from "../../components/MenuItemClickable";

import { getEnv } from "../../utils/appUtils";
import { APP_VERSION } from "../../utils/constants";

import { useThemeState } from "../../ThemeStateProvider";
import AdminMenu from "./AdminMenu";

const useStyles = makeStyles((theme) => ({
  env: {
    margin: "auto",
    paddingTop: theme.spacing(0),
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  },
  dev: {
    background: "#2fbb2f !important",
    color: "#ffffff !important",
  },
  hotfix: {
    background: "#FF9900 !important",
    color: "#ffffff !important",
  },
  prod: {
    background: "#ee2f2f !important",
    color: "#ffffff !important",
  },
}));

const AppMenu = (props) => {
  const { toggleContrast, togglePalette } = useThemeState();

  return (
    <UserMenu label="USER" icon={<MoreVertIcon />}>
      <MenuItemLink
        to={false}
        primaryText={window.appUser?.fullName}
        leftIcon={<ProfileIcon />}
      />
      <MenuItemClickable
        primaryText="Theme"
        leftIcon={<ThemeToggleIcon />}
        clickHandler={togglePalette}
      />
      <MenuItemClickable
        primaryText="Contrast"
        leftIcon={<ContrastIcon />}
        clickHandler={toggleContrast}
      />
      <MenuItemLink
        to="/logout"
        primaryText="Logout"
        leftIcon={<LogoutIcon />}
      />
    </UserMenu>
  );
};

const AdminAppBar = (props) => {
  const classes = useStyles();
  const env = getEnv();
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <AppBar
      {...props}
      color={"transparent"}
      className={
        env === "dev"
          ? classes.dev
          : env === "hotfix"
          ? classes.hotfix
          : classes.prod
      }
      userMenu={<AppMenu />}
      container={Fragment}
    >
      <AppBarHeader>
        <Typography variant="h4" className={classes.env}>
          {env} {APP_VERSION}
        </Typography>
      </AppBarHeader>
      {!xsDown && <KbChatButton />}
    </AppBar>
  );
};

export const AdminLayout = (props) => (
  <Layout
    {...props}
    appBar={AdminAppBar}
    menu={AdminMenu}
    notification={Notification}
  />
);
